import * as React from 'react';

import DiscoveryCreatorsSort from 'modules/discovery/creators/components/sort/DiscoveryCreatorsSort';
import CreatorTileResultsCount from 'components/creator-tile/results-count/CreatorTileResultsCount';
import CreatorTileSizing from 'components/creator-tile/sizing/CreatorTileSizing';
import CreatorTileSaveToCollection from 'components/creator-tile/save-to-collection/CreatorTileSaveToCollection';

import { SAVE_COLLECTION_MAX_NUM_RESULTS } from 'modules/discovery/creators/utils/creators';

import './creator-tile-interaction.scss';

import type { CreatorTileType } from 'types';

type Props = {
  orgId: number,
  type: CreatorTileType,
  totalItems: number,
  sort: string,
  isSavingToList: boolean,
  isFreemium: boolean,
  toggleIdsMap: {
    [type: number]: string
  },
  onGlobalResize: (value: string) => void,
  onSaveSearchToList: (c: string, b: string, a: number) => void
};

class CreatorTileInteraction extends React.PureComponent<Props> {
  renderResultsCount(): React.ReactNode {
    const { type, totalItems } = this.props;

    return (
      <CreatorTileResultsCount
        type={type}
        totalItems={totalItems}
      />
    );
  }

  renderSaveToCollection(): React.ReactNode {
    const { orgId, totalItems, isSavingToList, isFreemium, onSaveSearchToList } = this.props;
    const showSaveToCollection = totalItems > 0 && totalItems <= SAVE_COLLECTION_MAX_NUM_RESULTS;

    return (
      <div className="creator-tile-interaction__save-to-collection">
        <CreatorTileSaveToCollection
          orgId={orgId}
          show={showSaveToCollection}
          isSavingToList={isSavingToList}
          isFreemium={isFreemium}
          onSaveSearchToList={onSaveSearchToList}
        />
      </div>
    );
  }

  renderTileSizing(): React.ReactNode {
    const { totalItems, onGlobalResize, toggleIdsMap } = this.props;

    if (totalItems === 0) {
      return null;
    }

    return (
      <div className="creator-tile-interaction__size">
        <CreatorTileSizing
          onGlobalResize={onGlobalResize}
          toggleIdsMap={toggleIdsMap}
        />
      </div>
    );
  }

  renderDiscoverySort(): React.ReactNode | undefined | null {
    const { sort, totalItems, isFreemium } = this.props;

    if (totalItems === 0) {
      return null;
    }

    return (
      <DiscoveryCreatorsSort
        sort={sort}
        isFreemium={isFreemium}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <div className="creator-tile-interaction">
        {this.renderResultsCount()}
        {this.renderSaveToCollection()}
        {this.renderTileSizing()}
        {this.renderDiscoverySort()}
      </div>
    );
  }
}

export default CreatorTileInteraction;
